module.exports = __webpack_public_path__ + "img/faberlic-bg.791707f.jpg";